// Chainz Retail (Bazaars/POS) is released. Set REACT_APP_BAZAARS_ENABLED=false to show coming soon.
export const bazaarsEnabled = process.env.REACT_APP_BAZAARS_ENABLED !== 'false';
